import { Box, Flex, Text, Title } from "@mantine/core";

import { BuildProductQuoteResponse } from "@/types/api/quote";
import { ProductResume } from "./components/ProductResume";
import { calculatePlanTotalPrice } from "@/utils/calculate/calculatePlanTotalPrice";
import styles from "./styles.module.scss";
import { toBRL } from "@/utils/formatters/formatCurrency";

interface OrderSummaryProps {
  planDurationDays: number;
  quoteItems: BuildProductQuoteResponse[];
  shippingAmount: number;
}

export function OrderSummary({
  quoteItems,
  shippingAmount,
  planDurationDays,
}: OrderSummaryProps) {
  const quoteProducts = quoteItems.filter((quote) => quote.type === "product");
  const quoteGroups = quoteItems.filter((quote) => quote.type === "group");

  return (
    <>
      <Flex className={styles.resumeTitle}>
        <Title>Resumo da compra</Title>
      </Flex>

      <Box className={styles.productsContainer}>
        {quoteGroups.map(({ group }, i) => (
          <div key={i}>
            {group!.products.map((product, i2) => (
              <ProductResume product={product} key={i2} />
            ))}
          </div>
        ))}
        {quoteProducts.map(({ product }, i) => (
          <ProductResume product={product!} key={i} />
        ))}
      </Box>

      <Flex
        align="center"
        justify="space-between"
        mt={24}
        className={styles.shippingContainer}
      >
        <Title>Entrega</Title>
        <Text>
          {shippingAmount > 0 ? toBRL(shippingAmount) : "Preencha o Endereço"}
        </Text>
      </Flex>
      <Flex
        align="center"
        justify="space-between"
        mt={24}
        className={styles.totalContainer}
      >
        <Title>Total</Title>
        <Text>
          {toBRL(calculatePlanTotalPrice(quoteItems) + shippingAmount)}
          {planDurationDays === 90 && " (Plano Trimestral)"}
        </Text>
      </Flex>

      {planDurationDays > 0 && (
        <Box className={styles.aboutPlanContainer}>
          <Title>Sobre o Plano</Title>

          <Text className={styles.aboutPlanText}>
            <img src="/icons/check.png" alt="check-icon" />
            Plano flexível - Cancele, pause ou adie renovações sempre que quiser
          </Text>
        </Box>
      )}
    </>
  );
}
